document.addEventListener('DOMContentLoaded', () => {
  const moneyFormat = document.querySelector('[data-sevenvn-product-hero]')?.dataset.moneyFormat || '${{amount}}';

  const formatMoney = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(amount))));
  };

  document.querySelectorAll('[data-sevenvn-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-sevenvn-product-hero]');
      const main = gallery?.querySelector('[data-sevenvn-gallery-main]');
      const current = main?.querySelector('img, video, iframe, model-viewer');
      if (!main || !current || thumb.dataset.mediaType !== 'image') return;

      const nextSrc = thumb.dataset.fullSrc;
      const nextAlt = thumb.dataset.alt || '';
      current.style.opacity = '0';
      window.setTimeout(() => {
        if (current.tagName.toLowerCase() === 'img') {
          current.setAttribute('src', nextSrc);
          if (thumb.dataset.srcset) current.setAttribute('srcset', thumb.dataset.srcset);
          current.setAttribute('alt', nextAlt);
        } else {
          main.innerHTML = `<img class="netlify-main-product-media sevenvn-product-gallery__media" src="${nextSrc}" alt="${nextAlt}">`;
        }
        main.querySelector('img, video, iframe, model-viewer').style.opacity = '1';
      }, 120);

      gallery.querySelectorAll('[data-sevenvn-thumb]').forEach((item) => {
        item.classList.toggle('active', item === thumb);
        item.setAttribute('aria-current', item === thumb ? 'true' : 'false');
      });
    });
  });

  document.querySelectorAll('[data-sevenvn-accordion-list]').forEach((list) => {
    list.querySelectorAll('[data-sevenvn-accordion-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.sevenvn-product-accordion__item');
        const willOpen = !item.classList.contains('open');
        list.querySelectorAll('.sevenvn-product-accordion__item').forEach((entry) => {
          entry.classList.remove('open');
          entry.querySelector('[data-sevenvn-accordion-button]')?.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          item.classList.add('open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  document.querySelectorAll('.sevenvn-product-form').forEach((form) => {
    const select = form.querySelector('[data-sevenvn-variant-select]');
    const idInput = form.querySelector('[data-sevenvn-variant-id]');
    const price = form.querySelector('[data-sevenvn-price]');
    const compare = form.querySelector('[data-sevenvn-compare]');
    const submit = form.querySelector('[data-sevenvn-atc]');
    const stickyVariant = document.querySelector('[data-sevenvn-sticky-variant]');

    const syncVariant = () => {
      if (!select) return;
      const option = select.selectedOptions[0];
      if (!option) return;
      if (idInput) idInput.value = option.value;
      if (price) price.textContent = formatMoney(option.dataset.price);
      if (compare) {
        const compareValue = Number(option.dataset.compare || 0);
        const priceValue = Number(option.dataset.price || 0);
        compare.textContent = compareValue > priceValue ? formatMoney(compareValue) : '';
      }
      if (submit) {
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.childNodes[0].textContent = available ? submit.dataset.availableLabel : submit.dataset.soldoutLabel;
      }
      if (stickyVariant) stickyVariant.textContent = option.dataset.title || stickyVariant.textContent;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    };

    select?.addEventListener('change', syncVariant);
    syncVariant();

    form.addEventListener('submit', async (event) => {
      if (!form.matches('.shopify-product-form')) return;
      event.preventDefault();
      const submitButton = form.querySelector('[data-sevenvn-atc]');
      submitButton?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add this item.');
        submitButton.childNodes[0].textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        submitButton.childNodes[0].textContent = 'Try again';
      } finally {
        window.setTimeout(() => {
          submitButton?.removeAttribute('aria-busy');
          syncVariant();
        }, 1200);
      }
    });
  });

  document.querySelectorAll('[data-sevenvn-popup]').forEach((button) => {
    button.addEventListener('click', () => {
      const provider = button.dataset.sevenvnPopup;
      document.dispatchEvent(new CustomEvent('sevenvn:open-waitlist', { detail: { provider } }));
      if (provider === 'klaviyo' && window._klOnsite) {
        window._klOnsite.push(['openForm']);
      }
      if (provider === 'omnisend' && window.omnisend && typeof window.omnisend.open === 'function') {
        window.omnisend.open();
      }
    });
  });

  const sticky = document.querySelector('[data-sevenvn-sticky-bar]');
  const hero = document.querySelector('[data-sevenvn-product-hero]');
  const footer = document.querySelector('.site-footer, footer');
  if (sticky && hero) {
    const syncSticky = () => {
      const heroRect = hero.getBoundingClientRect();
      const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      const hasScrolledPastHero = window.scrollY > Math.max(180, hero.offsetHeight * 0.42) || heroRect.bottom < window.innerHeight * 0.78;
      const footerIsVisible = footerTop < window.innerHeight - 24;
      sticky.classList.toggle('visible', hasScrolledPastHero && !footerIsVisible);
    };
    syncSticky();
    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky);
  }
});
